import React from 'react'
import axios from 'axios'
import { CSNEW_API_URL } from '../lib/env'
import {
  Card,
  CardContent,
  Box,
  Chip,
  Grid,
  makeStyles,
  Button
} from '@material-ui/core'
import ListField from './list_field'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { green, red } from '@material-ui/core/colors'
import { HOLD, MISSED, SUCCESS } from '../constants/stuses'
import FieldInfo from '../asterX-UIkit/DisplayData/FieldInfo'

const useStyles = makeStyles(theme => ({
  status: {
    display: 'flex',
    flex: 1,
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end'
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  card: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgba(0,0,0,0.10)'
    }
  }
}))

function SalesDealItemOpa({
  deal,
  selectedTab,
  history,
  currentUser,
  showStatus,
  openButtonContent,
  onClickOpenButton,
  onClick
}) {
  const { client, saleStatus, closedByRop, assignToFullName } = deal
  // assignToFullName, createdByFullname,
  // const isOwner = (assignTo || createdBy) === currentUser.username;
  // const ownerFullName = assignToFullName || createdByFullname;
  const {
    firstName = '',
    lastName = '',
    middleName = '',
    phoneNumber = ''
  } = client
  const clientFullName = [lastName, firstName, middleName]
    .filter(name => !!name)
    .join(' ')
  const classes = useStyles()

  const handleClick = () => {
    if (selectedTab !== 0) {
      onClick && onClick(deal)
    }
  }

  const handleAccept = () => {
    axios
      .patch(
        `${CSNEW_API_URL}/salesStatus/updateStatusTrack`,
        {
          saleId: deal.id,
          status: 30
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )
      .then(response => {
        console.log(response.data)
        onClick(deal)
      })
  }

  const handleOpen = event => {
    event.stopPropagation()
    event.preventDefault()
    onClickOpenButton && onClickOpenButton(deal)
  }

  let statusComponent = (
    <Chip label={saleStatus ? saleStatus.name : 'Активный'} />
  )
  if (saleStatus && saleStatus.code === SUCCESS) {
    statusComponent = (
      <Chip
        label={saleStatus.name}
        style={{ backgroundColor: green[500], color: '#fff' }}
      />
    )
  }
  if (saleStatus && saleStatus.code === MISSED) {
    statusComponent = (
      <Chip
        label={saleStatus.name}
        style={{ backgroundColor: red[500], color: '#fff' }}
      />
    )
  }

  return (
    <Box my={2}>
      <Card
        className={classes.card}
        onClick={handleClick}
        elevation={0}
        variant="outlined"
        square
      >
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} md={1}>
              <ListField value={deal.id} title="ID" />
            </Grid>
            <Grid item xs={12} md={2}>
              <ListField value={clientFullName} title="Клиент" />
            </Grid>
            <Grid item xs={12} md={2}>
              {selectedTab === 0 && (
                <ListField
                  value={'+7 (***) *** ' + phoneNumber.substr(-5)}
                  title="Номер"
                />
              )}
            </Grid>
            {selectedTab === 0 && (
              <Grid item xs={12} md={2}>
                <ListField value={assignToFullName} title="Менеджер" />
              </Grid>
            )}
            {deal.saleStatus && deal.saleStatus.code === HOLD && (
              <Grid item xs={12} md={3}>
                <ListField
                  value={`${moment(deal.createdDate).format(
                    'DD.MM.YYYY HH:mm'
                  )} (Дней в работе: ${moment().diff(
                    moment(deal.createdDate),
                    'days'
                  )})`}
                  title="Первый контакт"
                />
              </Grid>
            )}
            <Grid item xs={12} md={2}>
              <ListField
                value={moment(deal.createdDate).format('DD.MM.YYYY HH:mm')}
                title="Дата последнего контакта"
              />
            </Grid>
            {showStatus && (
              <Grid container item xs={12} md={2} justifyContent="center">
                <Box display={'flex'} flexDirection={'column'}>
                  <Box component="span" mr={1}>
                    {statusComponent}
                  </Box>
                  <Box mr={1} mt={1} width={'100%'}>
                    <FieldInfo
                      label={'Cтатус :'}
                      value={deal?.saleStatusTrack?.trackStatus?.name || ''}
                    />
                  </Box>
                </Box>
                {saleStatus && saleStatus.code === SUCCESS && !!closedByRop && (
                  <span>
                    <Button
                      variant={'contained'}
                      size="small"
                      onClick={() => history.push(`/sales-print/${deal.id}`)}
                    >
                      Печать
                    </Button>
                  </span>
                )}
              </Grid>
            )}
            {selectedTab === 0 && (
              <Button
                className="button_green_color button_small"
                onClick={handleAccept}
              >
                Принять
              </Button>
            )}
            {!!onClickOpenButton && (
              <Grid container item xs={12} md={2} justify="center">
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={handleOpen}
                  >
                    {openButtonContent}
                  </Button>
                </span>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}

export default withRouter(SalesDealItemOpa)
